<script lang="ts">
  import { EXPIRY_STATE_TONE, type ExpiryState } from '@clinic/contracts';
  import { fa } from '../../../shared/i18n/fa';
  import { StatusBadge } from '../../../shared/ui';

  /** Expiry state (BR-10) as a badge; ok and none are not worth a badge in lists. */
  let { state, always = false }: { state: ExpiryState; always?: boolean } = $props();
</script>

{#if always || (state !== 'ok' && state !== 'none')}<StatusBadge tone={EXPIRY_STATE_TONE[state]} label={fa.inventory.expiryStates[state]} />{/if}
